module.exports = __webpack_public_path__ + "static/media/51_B.b1fb7b90.png";